import { useEffect } from 'react';
import { useLazyGetSiteStudyPersonnelCopyQuery } from 'src/services/SiteStudyPersonnel';
import {
  useCopyToSponsorMutation,
  useCreateIssueLogMutation,
  useDeleteAllMutation,
  useDeleteMutation,
  useLazyGetIssueLogBasedOnDateRangeQuery,
  useLazyGetIssueLogQuery,
  useUpdateAllIssueLogMutation,
  useUpdateIssueActionMutation,
  useUpdateIssueDecisionMutation,
  useUpdateIssueLogMutation
} from 'src/services/issueLog';
import { useAppSelector } from 'src/store/hooks';

export const useIssueLog = () => {
  const site = useAppSelector(state => state.site.selectedSite);
  const selectedStudy = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const [
    getIssueLogData,
    { data: issueLogData, error: issueLogDataError, isError: issueLogDataIsError, isLoading: issueLogDataIsLoading }
  ] = useLazyGetIssueLogQuery();

  const [
    updateIssueAction,
    {
      isSuccess: updateIssueActionIsSuccess,
      error: updateIssueActionError,
      isError: updateIssueActionIsError,
      isLoading: updateIssueActionIsLoading
    }
  ] = useUpdateIssueActionMutation();

  const [
    getSiteStudyPersonnelDataCopy,
    {
      data: siteStudyPersonalData,
      error: siteStudyPersonalError,
      isError: siteStudyPersonalIsError,
      isLoading: siteStudyPersonalIsLoading,
      isSuccess: siteStudyPersonalIsSuccess
    }
  ] = useLazyGetSiteStudyPersonnelCopyQuery();

  useEffect(() => {
    getSiteStudyPersonnelDataCopy({
      site_id: site as string,
      study_id: selectedStudy,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME
    });
  }, []);

  const [
    createIssueLog,
    {
      data: createIssueLogData,
      error: createIssueLogError,
      isError: createIssueLogIsError,
      isLoading: createIssueLogIsLoading,
      isSuccess: createIssueLogIsSuccess
    }
  ] = useCreateIssueLogMutation();
  const [
    updateIssueLog,
    {
      data: updateIssueLogData,
      error: updateIssueLogError,
      isError: updateIssueLogIsError,
      isLoading: updateIssueLogIsLoading,
      isSuccess: updateIssueLogIsSuccess
    }
  ] = useUpdateIssueLogMutation();

  const [
    deleteIssueLog,
    {
      data: deleteIssueLogData,
      error: deleteIssueLogError,
      isError: deleteIssueLogIsError,
      isLoading: deleteIssueLogIsLoading,
      isSuccess: deleteIssueLogIsSuccess
    }
  ] = useDeleteMutation();

  const [
    updateIssueDesision,
    {
      data: updateIssueDesisionData,
      error: updateIssueDesisionError,
      isError: updateIssueDesisionIsError,
      isLoading: updateIssueDesisionIsLoading,
      isSuccess: updateIssueDesisionIsSuccess
    }
  ] = useUpdateIssueDecisionMutation();

  const [
    deleteAllIssueLog,
    {
      data: deleteAllIssueLogData,
      error: deleteAllIssueLogError,
      isError: deleteAllIssueLogIsError,
      isLoading: deleteAllIssueLogIsLoading,
      isSuccess: deleteAllIssueLogIsSuccess
    }
  ] = useDeleteAllMutation();

  const [
    updateAllIssueLog,
    {
      data: updateAllIssueLogData,
      error: updateAllIssueLogError,
      isError: updateAllIssueLogIsError,
      isLoading: updateAllIssueLogIsLoading,
      isSuccess: updateAllIssueLogIsSuccess
    }
  ] = useUpdateAllIssueLogMutation();

  const [
    copyToSponsor,
    {
      data: copyToSponsorData,
      error: copyToSponsorError,
      isError: copyToSponsorIsError,
      isLoading: copyToSponsorIsLoading,
      isSuccess: copyToSponsorIsSuccess
    }
  ] = useCopyToSponsorMutation();

  const [
    getIssueLogBasedOnDateRange,
    {
      data: issueLogBasedOnDateRangeData,
      error: issueLogBasedOnDateRangeError,
      isError: issueLogBasedOnDateRangeIsError,
      isLoading: issueLogBasedOnDateRangeIsLoading,
      isSuccess: issueLogBasedOnDateRangeIsSuccess
    }
  ] = useLazyGetIssueLogBasedOnDateRangeQuery();

  return {
    issueLogData,
    issueLogDataError,
    issueLogDataIsError,
    issueLogDataIsLoading,
    getIssueLogData,
    siteStudyPersonalData,
    siteStudyPersonalError,
    siteStudyPersonalIsError,
    siteStudyPersonalIsLoading,
    siteStudyPersonalIsSuccess,
    updateIssueAction,
    updateIssueActionIsSuccess,
    updateIssueActionIsError,
    updateIssueActionError,
    updateIssueActionIsLoading,
    createIssueLog,
    createIssueLogData,
    createIssueLogIsSuccess,
    createIssueLogIsLoading,
    createIssueLogIsError,
    createIssueLogError,
    updateIssueLog,
    updateIssueLogData,
    updateIssueLogError,
    updateIssueLogIsError,
    updateIssueLogIsLoading,
    updateIssueLogIsSuccess,
    deleteIssueLog,
    deleteIssueLogData,
    deleteIssueLogError,
    deleteIssueLogIsError,
    deleteIssueLogIsLoading,
    deleteIssueLogIsSuccess,
    updateIssueDesision,
    updateIssueDesisionData,
    updateIssueDesisionError,
    updateIssueDesisionIsError,
    updateIssueDesisionIsLoading,
    updateIssueDesisionIsSuccess,
    deleteAllIssueLog,
    deleteAllIssueLogData,
    deleteAllIssueLogError,
    deleteAllIssueLogIsError,
    deleteAllIssueLogIsLoading,
    deleteAllIssueLogIsSuccess,
    updateAllIssueLog,
    updateAllIssueLogData,
    updateAllIssueLogError,
    updateAllIssueLogIsError,
    updateAllIssueLogIsLoading,
    updateAllIssueLogIsSuccess,
    copyToSponsor,
    copyToSponsorData,
    copyToSponsorError,
    copyToSponsorIsError,
    copyToSponsorIsLoading,
    copyToSponsorIsSuccess,
    getIssueLogBasedOnDateRange,
    issueLogBasedOnDateRangeData,
    issueLogBasedOnDateRangeError,
    issueLogBasedOnDateRangeIsError,
    issueLogBasedOnDateRangeIsLoading,
    issueLogBasedOnDateRangeIsSuccess
  };
};
